import {
    Action,
} from 'one-state';

import {
    ADD,
    SET,
    REINIT,
    DISABLE_ADD,
    SET_STATUS
} from './types';

import {
    NotesModel
} from 'one-card-notes-history';

/**
 * Redux action creator to set the list
 * of notes
 * @param notes list of pending referral
 * @returns action instance
 */
export const setAction = (notesData: NotesModel):
    Action<typeof SET, NotesModel> => ({
        type: SET,
        payload: notesData,
    });

/**
 * add note
 * @param note 
 * @returns action instance
 */
 export const addAction = (notes: NotesModel):
    Action<typeof ADD, NotesModel> => ({
        type: ADD,
        payload: notes,
    });

/**
 * diable add note
 * @param note 
 * @returns action instance
 */
 export const disableAddAction = (disable: boolean):
    Action<typeof DISABLE_ADD, boolean> => ({
        type: DISABLE_ADD,
        payload: disable,
    });


/**
* set save status 0: normal, 200: save success, 400: save error
* @param note 
* @returns action instance
*/
export const setStatusAction = (status: any):
Action<typeof SET_STATUS, any> => ({
    type: SET_STATUS,
    payload: status,
});
/**
 * Re-initialize the state
 * @returns action instance
 */
export const reinitAction = ():
    Action<typeof REINIT> => ({
        type: REINIT,
    });


/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof setAction> |
    ReturnType<typeof addAction> |
    ReturnType<typeof disableAddAction> | 
    ReturnType<typeof setStatusAction> | 
    ReturnType<typeof reinitAction>;